<template>
  <div class="card-details">
    <!-- type -->
    <div class="card-details__type">
      <CardModalDetailsType :card="card" type="recurrent" />
      <CardModalDetailsType :card="card" type="technical" />
    </div>
    <!-- users -->
    <!-- key provided for avoid duplicated event bus -->
    <div class="card-details__info">
      <CardModalCompany :account="card.account" />
      <CardUsers
        :title="$t('card_modal.ui.members')"
        :users="card.users || card.editors"
        :showEditor="isCardActive"
        :key="`card-${card.id}-users`"
      />
    </div>
  </div>
</template>

<script>
// Components
import CardUsers from 'Components/CardUsers'
import CardModalDetailsType from './CardModalDetailsType'
import CardModalCompany from './CardModalCompany'

export default {
  name: 'CardModalDetails',

  components: {
    CardUsers,
    CardModalCompany,
    CardModalDetailsType,
  },
  props: {
    card: {
      type: Object,
      required: true,
    },
  },

  computed: {
    isCardActive() {
      return this.card.status === 'active'
    },
  },
}
</script>

<style scoped>
.card-details {
  display: grid;
  justify-content: flex-start;
  gap: 15px;
}

.card-details__type {
  display: flex;
  flex-flow: row wrap;
}

.card-details__type {
  gap: 10px;
  user-select: none;
}

.card-details__info {
  display: flex;
  flex-flow: row wrap;
  align-items: flex-start;
  gap: 10px 25px;
}
</style>
